module.exports = __webpack_public_path__ + "static/media/studio2-1.3d88eaaa.png";